import {Component, OnInit, Query} from '@angular/core';
import {HttpService} from '../../shared/http.service';
import {ReservationResponse, ReservationRequest} from '@builtbybros/al-model';
import {QueryParam} from '../../shared/query-param';
import {InitjsService} from '../../shared/initjs.service';
import moment = require('moment');
import {ActivatedRoute, Params} from '@angular/router';
import {AlertService} from '../../shared/alert.service';

@Component({
  selector: 'app-reservation-categories',
  templateUrl: './reservation-categories.component.html',
  styleUrls: ['./reservation-categories.component.scss']
})
export class ReservationCategoriesComponent implements OnInit {

  entity = 'reservation/reservation-categories/';
  title = 'Reservas de escuelas';
  reservations = {};
  reservationsReady = false;
  actions = true;
  prevPath = '../../';
  msg = {
    'changeStatus': 'Estado cambiado correctamente',
    'delete': 'Reserva borrada correctamente'
  };

  columns = [];
  // [api param, column name, isSortable]
  kindColumns = {
    '3': [
      ['companyName', 'Empresa', false], // userid.companyName
      ['contactName', 'Nombre Contacto', false], // userid.contactName
      ['initialDate', 'Fecha Inicial', false],
      ['expirationDate', 'Válido hasta', false],
    ],
    '4': [
      ['instituteName', 'Institución', false], // userid.instituteName
      ['contactName', 'Nombre Contacto', false], // userid.contactName
      ['initialDate', 'Fecha Inicial', false],
      ['expirationDate', 'Válido hasta', false],
    ]
  };

  // [name, table header, isVisible]
  actionColumns = [
    ['highlight', 'Destacar', false],
    ['edit', 'Editar', true],
    ['delete', 'Eliminar', true],
    ['changeStatus', 'Cambiar Estado', true]
  ];

  states = [
    [1, 'Pendiente'],
    [2, 'Aceptado'],
    [3, 'Rechazado'],
    [4, 'Cancelado'],
    [5, 'Entregado'],
    [6, 'Expirado']
  ];

  categories = [
    [1, 'Admin'],
    [2, 'Usuarios'],
    [3, 'Consignatarios'],
    [4, 'Escuelas']
  ];

  hasDataTables = false;

  // getAllBooks filters
  pagination = 10;
  offset = 0;
  sort = '-id';
  query = '';
  category = 3;
  status = 0;

  constructor(private httpService: HttpService,
              private route: ActivatedRoute,
              private initJsService: InitjsService,
              private alertService: AlertService) { }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      if (params['reservationCategory']) {
        this.category = +params['reservationCategory'];
        this.entity = 'reservation/reservation-categories/' + params['reservationCategory'];
        this.title = `Reservas de ${this.categories[this.category - 1][1]}`;
        this.columns = this.kindColumns[this.category];
        this.getAllReservations();
        this.initJsService.initJs();
      }
    });
  }

  getAllReservations() {
    const params = new Array<QueryParam>();
    params[0] = new QueryParam('pagination', this.pagination.toString());
    params[1] = new QueryParam('offset', this.offset.toString());
    params[2] = new QueryParam('category', this.category.toString());
    if (this.status) {
      params.push(new QueryParam('status', this.status.toString()));
    }
    if (this.sort !== '') {
      params.push(new QueryParam('order', this.sort));
    }
    this.httpService.getWithParams('/Reservation/All', params, ReservationResponse.All)
      .subscribe(
        reservationsResponse => {

          this.reservations = reservationsResponse;

          for (const res of this.reservations['objects']) {
            res['initialDate'] = moment(res['initialDate']).format('DD/MM/YYYY');
            res['expirationDate'] = moment(res['expirationDate']).format('DD/MM/YYYY');
            if (this.category === 3) {
              res['companyName'] = res.user.companyName;
              res['contactName'] = res.user.name + ' ' + res.user.lastName;
            } else if (this.category === 4) {
              res['instituteName'] = res.user.instituteName;
              res['contactName'] = res.user.name;
            }
          }

          this.reservationsReady = true;
        },
        error => {
          this.alertService.error(error);
        }
      );
  }

  setState(val) {
    const reservation = new ReservationRequest.Update();
    reservation.status = +val[1];
    const responseExpected = new ReservationResponse.Reservation();
    this.httpService.patch(val[0], '/Reservation/', reservation, responseExpected)
      .subscribe(
        reservationResponse => {
          this.alertService.success(this.msg['changeStatus']);
          this.getAllReservations();
        },
        error => {
          this.alertService.error(error);
        }
      );
  }

  setLimit(value) {
    this.pagination = +value;
    this.getAllReservations();
  }

  setOffset(value) {
    this.offset = +value;
    this.getAllReservations();
  }

  setQuery(value) {
    this.query = value;
    this.getAllReservations();
  }

  setOrder(value) {
    this.sort = (this.sort === value) ? `-${value}` : value;
    this.getAllReservations();
  }

  delete(value) {
    this.httpService.delete('/Reservation/', +value)
      .subscribe(
        updateResponse => {
          this.getAllReservations();
        },
        error => {
          this.alertService.error(error);
        },
        () => {
          this.alertService.success(this.msg['delete']);
        }
      );
  }

  filterStates(value) {
    this.status = +value;
    this.getAllReservations();
  }

}



// WEBPACK FOOTER //
// ./src/app/reservation/reservation-categories/reservation-categories.component.ts